<template>
  <div class="main-content">
    <section class="section">
      <PageHeader
        v-if="!isMobile"
        :formData="formData"
        :wfDtl="wfDtl"
        :isShow="isShow"
        :page="this"
      >
        <template slot="buttons">
          <div class="mt-3 mt-lg-0 mr-lg-3">
            <button type="button" class="btn btn-primary legitRipple" @click="wfDiagramBtnClick()">
              <i class="fas fa-project-diagram mr-2"></i>Workflow Diagram
            </button>
          </div>
          <div class="mt-3 mt-lg-0 mr-lg-3">
            <button
              type="button"
              class="btn btn-primary legitRipple"
              @click="SubmitButtonClicked()"
            >
              <i class="fas fa-check-square mr-2"></i>Submit
            </button>
          </div>
        </template>
      </PageHeader>
      <PageMobileHeader
        v-if="isMobile"
         :formData="formData" 
        :wfDtl="wfDtl"
        :gridData="gridData"
        @wfAction="wfAction"
        @wfNoteChanged="wfNoteChanged"
        :deleteList="deleteList"
        :page="this"
      >
        <template slot="buttons">
          <div class="mt-3 mt-lg-0 mr-lg-3"> 
            <button type="button" class="btn btn-primary legitRipple" @click="wfDiagramBtnClick()">
              <i class="fas fa-project-diagram mr-2"></i>Workflow Diagram
            </button>
          </div>
          <div class="mt-3 mt-lg-0 mr-lg-3">
            <button type="button" class="btn btn-primary legitRipple" @click="saveButtonClicked()">
              <i class="far fa-save"></i>Save
            </button>
          </div>
          <div class="mt-3 mt-lg-0 mr-lg-3">
            <button type="button" class="btn btn-light legitRipple" @click="cancelBtnClick()">
              <i class="far fa-window-close mr-2"></i>Cancel
            </button>
           </div>
        </template>
      </PageMobileHeader>
      <div class="section-body">
        <div class="card" style="padding-top:5px">
        <!-- {{filters[3]}} -->
        <div class="card-header">
          <h4>Workflow History</h4>
          <div id="card-action" class="card-header-action" style="max-width: 150px;">
            <h4>Status: {{wfDtl.curStep!=null?wfDtl.curStep.description:""}}</h4>
          </div>
          <template v-if="computedIcon">
            <div class="col-md-1" v-if="ticon">
              <i
                class="fas fa-chevron-down float-right align-middle btn btn-circle"
                @click="toggleIcon"
              ></i>
            </div>
            <div class="col-md-1" v-if="!ticon">
              <i
                class="fas fa-chevron-up float-right align-middle btn btn-circle"
                @click="toggleIcon"
              ></i>
            </div>
          </template>
        </div>
        <div :style="{ display: ticon ? 'block' : 'none' }">
          <div class="card-body">
            <table class="table table-bordered">
              <thead class="header-bocigrey">
                <tr>
                  <th style="width: 10%">Action</th>
                  <th style="width: 25%">Action By</th>
                  <th style="width: 15%">Received On</th>
                  <th style="width: 15%">Action Date</th>
                  <th style="width: 35%">Comment</th>
                </tr>
              </thead>
              <tbody v-for="(workflow, index) in wfDtl.wfHistory" :key="index">
                <tr>
                  <td style="width: 10%">{{workflow.action}}</td>
                  <td style="width: 25%">{{workflow.user_name}}</td>
                  <td style="width: 15%">{{previousAction(wfDtl.wfHistory,index)}}</td>
                  <td style="width: 15%">{{formatDateTime(workflow.action_on)}}</td>
                  <td style="width: 35%">{{workflow.note}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
        <div class="card">
          <div class="card-body">
            <div class="row">
              <Textbox title="Staff Name" v-model="formData.staff_name" class="col-sm-12" />
            </div>
          </div>
        </div>

        <div class="card">
          <div class="card-header">
            <h4>Change of Address</h4>
          </div>
          <div class="card-body">
            <div class="row">
              <Textbox title="Street Name" v-model="formData.street_name" class="col-sm-12" />
            </div>
            <div class="row">
              <Textbox title="Subrub" v-model="formData.subrub" class="col-sm-6" />

              <Textbox title="Postcode" v-model="formData.postcode" class="col-sm-6" />
            </div>
          </div>
        </div>

        <div class="card">
          <div class="card-header">
            <h4>Change of Bank Account</h4>
          </div>
          <div class="card-body">
            <div class="row">
              <Textbox title="Account Name" v-model="formData.account_name" class="col-sm-12" />
            </div>
            <div class="row">
              <Textbox title="BSB" v-model="formData.bsb" class="col-sm-6" />
              <Textbox title="Account Number" v-model="formData.account_number" class="col-sm-6" />
            </div>
          </div>
        </div>

        <div class="card">
          <div class="card-header">
            <h4>Change of Personal Contact</h4>
          </div>
          <div class="card-body">
            <div class="row">
              <Textbox title="Personal contact number" v-model="formData.personal_contact_number" class="col-sm-6" />
              <Textbox title="Emergency contact number" v-model="formData.emergency_contact_number" class="col-sm-6" />
            </div>
          </div>
        </div>
      </div>
    </section>
    <!--Submit Model-->
    <div
      id="wfDiagramModal"
      class="modal fade so-alert-dialog in"
      aria-hidden="true"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg bootstrap-dialog">
        <div class="modal-content">
          <div class="modal-body">
            <div id="graph"></div>
          </div>
          <div class="modal-footer">
            <button class="btn btn-primary" data-dismiss="modal">OK</button>
          </div>
        </div>
      </div>
    </div>
    <!--Submit Model-->
  </div>
</template>


<script>
import api from "@/api";
import { mapActions, mapGetters } from "vuex";
import helper from "@/vueHelper";

export default {
  title: "Change of personal details form",
  access_code: "P_CHANGE01",
  components: {},
  order: 4,
  hidden: true,
  data() {
    return {
      isShow: null,
      gridId: "form01",
      formData: {
      },
      wfDtl:{},
      ticon: false,
      isMobile:false
    };
  },
  created() {
    if(this.$router.history.current.path.indexOf("/Mobile/")){
       this.isMobile=false;
       }else{
        this.isMobile=true;
    }
    if (window.innerWidth < window.innerHeight || window.innerWidth > 768) {
      this.isShow = false;
    } else {
      this.isShow = true;
    }
  },
  computed: {
    computedIcon() {
      if (this.icon == undefined) {
        return true;
      }

      return this.icon;
    },
  },
  mounted() {
    this.loadForm();
    window.addEventListener("resize", () => {
      if (window.innerWidth < window.innerHeight) {
        this.isShow = false;
      } else {
        this.isShow = true;
      }
    });
  },
  methods: {
    toggleIcon() {
      this.ticon = !this.ticon;
    },
    wfDiagramBtnClick() {
      $("#wfDiagramModal").modal("show");
    },
    loadGraph() {
      var graph = new Graph(document.getElementById("graph"));
      graph.resizeContainer = true;
      graph.setEnabled(false);

      //var data = "7Vpdc6M2FP01ntk+lAEJMDz6c5tp15uJ0+32aUcG2WiDERUitvfXV4D4tj0bx4mhUzLjoCPpCumec7mSPYCT7f4jQ6H3ibrYHwDV3Q/gdADA0DLFZwIcMkDX7AzYMOJmkFYCS/IDS1CVaExcHNUackp9TsI66NAgwA7PMNkXMUZ3UQ1aU78+aog2uAUsHeS30b+Iy70MtQy1xH/DZOPJkTVNTWvgbAAnjFKe3W33E+wn65LPOes+P1FbDMpwwI90+DPC7PPqezJfoPpoJZY8bTQAxgJtsfgnDfjIwZ6YMmb11UpbpcCSI8YzcIojh5GQExq06n7H0n/Lx9HDY4YVT1vOuJhJxA/5CkYeCpPb7X6TMERZ+3TneMKywjHbkgBxygZwvPMIx8tQPLBouxMtBebxbTIzTdxGnNGnwgWwQCbUT7qLgaBtjg3LEDVr4vsVfGzP1FGCP6WTqMygusByZZ4x43hfgeS8PmK6xZwdRBNZq0sKHOrFXckSLWedV2GImZNTemRTGC79K27kSubFisevzYAH/Ezw7gQFviBG0MrHWosGs/sGC7SzLGA0DlyctFVf6mxwzNkjLfkTNdf3pGb11ZWjMGT0Gb/el+C/4kuoGT315SxwT/ixqCk8OFtMGw6E3QjJY8uGNmyH5Pl8Iq4iJBfPf03XG2ZfZbyMV1vCwam3clqbVa42Ex9FUT5SSgGRCbXAiCMeR1+QH+MqzLCDiVhgKWsUPH1YU7YdwBFyeIz8b7GYVPohiAUm2i+ym2hYNSNGdEn5gLntf2LCsLugvDYmijldchxWsYLIo8nj3edFg8v6WS5jV+RrskgZ9+iGBsiflei4Hq7KNn9QGkoqf8ecH2TymTxgnegnuRnRmDmNhFXkTBtcZIMZljzjWQZXKGocYWiOMewjLhxWe4hjtJUj3FMS8FIgmt1MWRrMz+Yje1Xz04ahVpQ1GoayRWgZSlVUTLtr78fbCQvcRlhGP4SVb/uqwgLdEpbWyCC1C4XVMmT3Q1gPODPzvrp6lWg4i/GlwjFvLRy8J/xr0l2xbVOW/07Lhm7I8nQv7aeFQ6VwL8KOYEq6jCkWCNZ8zU0nBWkLDnOgNJaWDtVS09zlqlY7pWoINcW01PIya9oUQUgBoFINL9M8hKpSsaJqtVGG5wf5Px50IR4MOxwPgP6KeKAkpK/HBB28XUwAr4gJUk2/qooOjfam/w3jhNhAKpbe1mh5BFHTdx5GXpx0m43sXVMMw65cxk+FhtJu3pCu1xHuVPgYOalej4ePauV103Tq4w/zu8VoMZl9G00/3S1ukpaD88fpnUnLj4gVdGu/C6yGYprZ9Ate0XVDej/S8jkJUCAcBtRrnQzXHNrrk2G9t1/YnPdlrbY76dWlwRD0IhiCY7sZ2Klg2DxagFYjX7j0jELvyeHf2T3JmyUVNxHN+W9/3nE/Umwgyv3IdXcj5tudUBzV9Mt3I8bQslovmvdMegxNMUHdyk9vOYZ1W6D5hcF77zEEVP6oJrNQ/uoIzv4F";
      var data = this.wfDtl.wfdesigner;
      if (data != null) {
        var wfdataraw = Graph.decompress(data);
        var xmlDoc = mxUtils.parseXml(wfdataraw);
        var codec = new mxCodec(xmlDoc);
        codec.decode(xmlDoc.documentElement, graph.getModel());

        var model = graph.getModel();
        var currentSelectedVertex = null;
        var isStartOrEnd = false;
        var lookupWord = this.wfDtl.curStep.description;
        for (const property in model.cells) {
          if (
            model.cells[property].value !== undefined &&
            model.cells[property].value.tagName == "UserObject"
          ) {
            if (model.cells[property].value.getAttribute("Key") == "STEP") {
              if (
                model.cells[property].value.getAttribute("Name") == lookupWord
              ) {
                currentSelectedVertex = model.cells[property];
                isStartOrEnd = false;
                break;
              }
            } else if (
              model.cells[property].value.getAttribute("Key") == "START" ||
              model.cells[property].value.getAttribute("Key") == "END"
            ) {
              if (
                model.cells[property].value.getAttribute("Name") == lookupWord
              ) {
                currentSelectedVertex = model.cells[property];
                isStartOrEnd = true;
                break;
              }
            }
          }
        }

        if (currentSelectedVertex != null) {
          //Adds animation to edge shape and makes "pipe" visible
          var state = graph.view.getState(currentSelectedVertex);
          if (isStartOrEnd) {
            state.shape.node
              .getElementsByTagName("path")[0]
              .removeAttribute("visibility");
            state.shape.node
              .getElementsByTagName("path")[0]
              .setAttribute("stroke-width", "4");
            state.shape.node
              .getElementsByTagName("path")[0]
              .setAttribute("stroke", "gray");
            state.shape.node
              .getElementsByTagName("path")[0]
              .setAttribute("class", "flow");
          } else {
            var state = graph.view.getState(currentSelectedVertex);
            state.shape.node
              .getElementsByTagName("rect")[0]
              .removeAttribute("visibility");
            state.shape.node
              .getElementsByTagName("rect")[0]
              .setAttribute("stroke-width", "4");
            state.shape.node
              .getElementsByTagName("rect")[0]
              .setAttribute("stroke", "gray");
            state.shape.node
              .getElementsByTagName("rect")[0]
              .setAttribute("class", "flow");
          }
        }
      }
    },
    loadForm() {
      var vm = this
      helper.loading();
      api.request(
        this,
        "post",
        `/personal_form/${this.gridId}_load`,
        {
          SessionID: helper.getSessionID(),
          LocaleCode: helper.getLocaleCode(),
          //LocaleCode: this.$store.state.user.locale_code,
          Parameters: {
            id: this.$route.params.id,
            preparer_user_userid: helper.getUserID(),
            actual_user_userid: helper.getUserID()
          }
        },
        function(r) {
          this.wfDtl = r.data.wfDtl;
          this.formData = r.data.formData;
          this.$nextTick(function () {

          })
          
          helper.done();

          this.loadGraph();
        },
        function(r) {
          helper.done();
        },
        null
      );
    },
      SubmitButtonClicked() {
      helper.loading();
      api.request(
        this,
        "post",
        `/personal_form/${this.gridId}_save`,
        {
          SessionID: helper.getSessionID(),
          LocaleCode: helper.getLocaleCode(),
         Parameters: {
            id: this.$route.params.id,
            formData: this.formData
          }
        },
        function(r) {
          helper.clearData(this);
          this.$router.go(0);
        },
        function(r) {
          helper.done();
        }
      );
    }
  }
};
</script>

<style scoped>
.section-body {
  padding-top: 100px;
}
</style>